import { Link } from 'react-router-dom';
import { useLanguage } from '../utils/i18n';
import Logo from '../components/Logo';
import LanguageToggle from '../components/LanguageToggle';

export default function TermsOfService() {
    const { t } = useLanguage();

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
            {/* Navbar */}
            <nav className="navbar">
                <Link to="/" className="navbar-brand">
                    <Logo size={24} />
                    <span>Wafiyo</span>
                </Link>
                <LanguageToggle />
            </nav>

            <div className="container" style={{ maxWidth: 720, paddingTop: 48, paddingBottom: 80 }}>
                <div className="glass-card" style={{ padding: '40px 32px' }}>

                    <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>{t('tos_title')}</h1>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 32 }}>{t('legal_last_updated')}: 26/02/2026</p>

                    <div className="legal-content">
                        <section>
                            <h2>{t('tos_acceptance_title')}</h2>
                            <p>{t('tos_acceptance_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_service_title')}</h2>
                            <p>{t('tos_service_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_accounts_title')}</h2>
                            <p>{t('tos_accounts_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_payment_title')}</h2>
                            <p>{t('tos_payment_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_usage_title')}</h2>
                            <p>{t('tos_usage_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_ip_title')}</h2>
                            <p>{t('tos_ip_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_termination_title')}</h2>
                            <p>{t('tos_termination_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_liability_title')}</h2>
                            <p>{t('tos_liability_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_governing_title')}</h2>
                            <p>{t('tos_governing_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_changes_title')}</h2>
                            <p>{t('tos_changes_text')}</p>
                        </section>

                        <section>
                            <h2>{t('tos_contact_title')}</h2>
                            <p>{t('tos_contact_text')}</p>
                        </section>
                    </div>

                    <div style={{ marginTop: 32, textAlign: 'center' }}>
                        <Link to="/" className="btn btn-outline btn-sm glass-btn">{t('back_to_home')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
